import React, { useState } from 'react'
import { UIProperties } from '../UIProperties';
import CoreGeneralButton from './core-general-button';

import "./core-general-aar-ui.css"
import { UIBaseImplementation } from '../../../UI/UIBaseImplementation';
import { getGlobalTextSizeStyle, parseDynamicHtml, TextHtmlTagType } from '../../../../misc/tools';
import { constants } from '../../../../misc/constants';

export interface GeneralAARUIBaseImplementation {
	getScore: () => GetScoreResult;
	getPercentage: () => string;
}

class CoreGeneralAARUIBaseImplementation extends UIBaseImplementation {
	public getImplementation(config: GeneralAARUIConfig): GeneralAARUIBaseImplementation {
		let currentScore = 0;
		let maxScore = 0;
		for(var indx = 0; indx < config.entries.length; indx++) {
			var entry = config.entries[indx];
			currentScore += entry.scoreAwarded;
			maxScore += entry.scorePossible;
		}

		const score: GetScoreResult = {
			currentScore: currentScore,
			maxScore: maxScore
		};

		return {
			getScore: (): GetScoreResult => {
				return score;
			},
			getPercentage: (): string => {
				return (((score.currentScore / score.maxScore) * 100).toFixed(0)) + '%';
			}
		}
	}
}

export const coreGeneralAARUIBaseImplementation = new CoreGeneralAARUIBaseImplementation();

const CoreGeneralAARUI = (props: UIProperties<GeneralAARUIConfig>) => {
	const baseImplementation = coreGeneralAARUIBaseImplementation.getImplementation(props.parameters);
	const score = baseImplementation.getScore();
	const percentage = baseImplementation.getPercentage();

	return (
		<div className={`modal-disable-select core-general-aar-ui-container`} style={{
		}}>
			<div className={`core-general-aar-ui-inner-container center-element ${constants.mainContent508Id}`} aria-label='After Action Review'>
				<h1 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h1)}} className='core-general-aar-ui-header title-text center-element'>After Action Review</h1>
				<div id='aar-content-top' tabIndex={0} style={{fontWeight: 'bold'}} className='core-general-aar-ui-score center-element-horizontal'>
					<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text black-text'>
						{score.currentScore + ' out of ' + score.maxScore + ' (' + percentage + ') - '}
						<span dangerouslySetInnerHTML={{ __html: 
							(props.parameters.onGetIfPassed() ? '<span style="color: #1F6E08">Completed</span>' : '<span style="color: #960303">Incomplete</span>')}}></span></p>
				</div>
				<div className='core-general-aar-ui-content center-element-horizontal'>
					{props.parameters.entries.map((entry: GeneralAARUISingleEntryConfig, indx: number) => {
						return  (
							<div className='core-general-aar-ui-content-single-element'>
								<table>
									<tr>
										<td aria-label={'Question: ' + (indx + 1)} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-scen default-text'>{'Question: ' + (indx + 1)}</td>
									</tr>
									<tr>
										<td aria-label={'Question'} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-question default-text'>Question: </td>
									</tr>
									<tr>
										<td aria-label={entry.questionTitle} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-title default-text'>{entry.questionTitle}</td>
									</tr>
									<tr>
										<td aria-label={'Is Correct'} className='aar-correct default-text' style={{color: entry.isCorrect ? '#1F6E08' : '#960303', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}}>{'Is Correct: '}</td>
										<td aria-label={(entry.isCorrect ? 'Yes' : 'No')} className='aar-verdict default-text' style={{color: entry.isCorrect ? '#1F6E08' : '#960303', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}}>{(entry.isCorrect ? 'Yes' : 'No')}</td>
									</tr>
									<tr>
										<td aria-label={'Awarded Score'} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-award default-text'>{'Awarded Score: '}</td>
										<td aria-label={entry.scoreAwarded.toString()} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-award-score default-text'>{entry.scoreAwarded}</td>
									</tr>
									<tr>
										<td aria-label={'Possible Score'} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-poss default-text'>{'Possible Score: '}</td>
										<td aria-label={entry.scorePossible.toString()} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-poss-score default-text'>{entry.scorePossible}</td>
									</tr>
									<tr>
										<td aria-label={'Feedback'} style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-feedback-top default-text'>Feedback:</td>
									</tr>
									<tr>
										<td style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='aar-feedback-bot' dangerouslySetInnerHTML={{ __html: parseDynamicHtml("<p><span>"+ entry.feedback +"</span></p>") }}></td>
									</tr>
								</table>
								{/* <p className='default-text' style={{color: 'black', fontWeight: 'bold'}}>{'Scenario: ' + (indx + 1)}</p>
								<br />
								<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>{'Question: ' + entry.questionTitle}</p>
								<br />
								<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text' style={{color: entry.isCorrect ? '#1F6E08' : '#960303'}}>{'Is Correct: ' + (entry.isCorrect ? 'Yes' : 'No')}</p>
								<br />
								<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>{'Awarded Score: ' + entry.scoreAwarded}</p>
								<br />
								<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>{'Possible Score: ' + entry.scorePossible}</p>
								<br />
								<div dangerouslySetInnerHTML={{ __html: "<p><span class=\"default-text\">Feedback:</span><span>"+ entry.feedback +"</span></p>" }}></div> */}
								

								<hr />
							</div>
						)
					})}
				</div>
				<div className='center-element-horizontal core-general-aar-ui-submit'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						idFor508='aar-content-bottom'
						onClick= {props.parameters.onCloseClicked}
						onRenderContent= {() => {
							return (
								<p style={{pointerEvents: 'none', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='small-text center-element black-text'>Close</p>
							)
						}}
						bgColor= {'#D3E1EA'}
						hoverColor={'rgb(159, 191, 211)'}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Close'}></CoreGeneralButton>
				</div>
			</div>
		</div>
	);

};

export interface GeneralAARUIConfig {
	entries: GeneralAARUISingleEntryConfig[];
	onGetIfPassed: () => boolean;
	onCloseClicked: () => void;
}

export interface GeneralAARUISingleEntryConfig {
	questionTitle: string;
	selectedOption: string;
	feedback: string;
	isCorrect: boolean;
	scoreAwarded: number;
	scorePossible: number;
}

export interface GetScoreResult {
	currentScore: number;
	maxScore: number;
}

export default CoreGeneralAARUI;